import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Anchor, Drop } from 'wt-ui';

const TextHeaderWithDrop = ({ text, dropText }) => {
  const [over, setOver] = useState(false);
  const ref = useRef(null);

  return (
    <>
      <Box gap="small" align="center" direction="row">
        <Anchor
          onMouseOver={() => setOver(true)}
          onMouseOut={() => setOver(false)}
          onFocus={() => {}}
          onBlur={() => {}}
          forwardRef={ref}
          style={{ width: '100%' }}
        >
          {typeof text === 'string' ? <Text color="#fff">{text}</Text> : <>{text}</>}
        </Anchor>
      </Box>
      {ref.current && over && (
        <Drop align={{ top: 'bottom', right: 'right' }} target={ref.current}>
          <Box pad="small" background="transparent" width="small">
            {dropText}
          </Box>
        </Drop>
      )}
    </>
  );
};

TextHeaderWithDrop.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  dropText: PropTypes.string.isRequired,
};

export default TextHeaderWithDrop;
